<template>
    <div class="table_wrap">
        <div class="pagnation_wrap home-pagebar">
            <div class="inline-block" v-if="paginationData.total > 0">
                <el-button class="pagebar-button" icon="el-icon-arrow-left" :disabled="page === 1"
                           @click="changePage('page', page - 1)"></el-button>
                <el-pagination
                    :page-size="paginationData.size"
                    :current-page.sync="page"
                    :pager-count="11"
                    :total="paginationData.total"
                    @current-change="changePage('page', page)"
                    class="bottom-pagebar"
                    layout="pager"
                    background>
                </el-pagination>
                <el-button class="pagebar-button" icon="el-icon-arrow-right" :disabled="page === returnLastPage()"
                           @click="changePage('page', page + 1)"></el-button>
            </div>
        </div>
        <div class="table_search row has_bc">
            <el-row>
                <el-col :span="12">
                    <el-button type="info" size="small" class="p_del_btn" @click="multipleUpdateStatus(30)">배송준비중 처리</el-button>
                    <el-button type="info" size="small" class="p_del_btn" @click="multipleCancel()">주문 취소</el-button>

                </el-col>
                <el-col class="text_right" :span="12">
                    <el-button type="success" size="small" class="text-right mr10" @click="excelDown">엑셀 출력</el-button>

                    <el-select v-model="sort" @change="setPageSort()" class="mr10">
                        <el-option v-for="item in pageSort" :key="item.value"
                                   :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select
                        v-model="pageRow"
                        @change="setPageRow()"
                    >
                        <el-option
                            v-for="row in pageRows"
                            :key="row"
                            :label="`${row}개 씩보기`"
                            :value="row"
                        ></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import alertMixins from '@/mixins/alertMixins';
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";
import orderSortService from "@/service/orderSortService";

export default {
    name: "PaginationItemReadyLayout",
    mixins: [alertMixins,orderSortService],
    components: {},
    inject: ['setPage', 'setSort','excelDown'],
    provide() {
        return {}
    },
    props: {
        orderType:'',
        paginationData: {
            type: Object,
            default: {
                total: 0,
                page: 0,
                size: 0,
            }
        },
        sortData: {default: () => {}},
    },
    data() {
        return {
            page: 1,
            size: 10,
            pageRow: 10,
            pageRows: [10, 30, 50],
            sort: 'order_date-asc',
            pageSort: this.returnOrderSort(this.orderType),
            selectRow: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.setFilterSort()
    },
    mounted() {
        this.page = this.paginationData.page;
        this.pageRow = this.paginationData.size;
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setFilterSort(){
            this.sort = this.sortData.key+"-"+this.sortData.order
        },
        changePage(key, value) {
            this.setPage(key, value);
        },
        returnLastPage() {
            return Math.ceil(this.paginationData.total / this.paginationData.size);
        },
        setPageRow() {
            this.setPage('size', this.pageRow)
        },
        setPageSort(){
            let arrSort = this.sort.split("-")
            this.setSort(arrSort[0],arrSort[1])
        },
        multipleUpdateStatus(status){
            EventBus.$emit('itemReadyMultipleUpdateStatus', status)
        },
        multipleCancel(){
            EventBus.$emit('itemReadyMultipleCancel')
        }
    },
    watch: {
        'paginationData.page': {
            deep: true,
            handler: function (val, oldVal) {
                this.page = this.paginationData.page;
            }
        },
        'paginationData.size': {
            deep: true,
            handler: function (val, oldVal) {
                this.pageRow = this.paginationData.size;
            }
        }
    },
}
</script>

<style scoped>

</style>
